// =============================================================================
// GuestContext - Contexte global pour détecter le rôle Invité
// Un invité ne peut effectuer AUCUNE action dans la plateforme
// =============================================================================

import React, { createContext, useContext, useMemo } from 'react';

interface GuestContextValue {
  /** true si l'utilisateur courant a le rôle 'guest' dans l'organisation */
  isGuest: boolean;
}

const GuestContext = createContext<GuestContextValue>({ isGuest: false });

export function GuestProvider({ isGuest, children }: { isGuest: boolean; children: React.ReactNode }) {
  // Batch 5A (Q3): memoize context value.
  const value = useMemo(() => ({ isGuest }), [isGuest]);
  return (
    <GuestContext.Provider value={value}>
      {children}
    </GuestContext.Provider>
  );
}

/**
 * Hook pour vérifier si l'utilisateur courant est un invité.
 * Les invités n'ont accès à AUCUNE action dans la plateforme.
 */
export function useIsGuest(): boolean {
  return useContext(GuestContext).isGuest;
}
